import React from 'react';

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.link/7xump2"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 bg-[#25D366] rounded-full shadow-lg hover:scale-110 hover:shadow-xl transition-all duration-300 ease-in-out md:w-16 md:h-16"
      aria-label="Chat on WhatsApp"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        className="w-8 h-8 md:w-9 md:h-9 fill-white"
      >
        <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.118-1.958A15.923 15.923 0 0 0 16.004 32C24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.316 22.59c-.39 1.1-1.932 2.014-3.182 2.28-.856.18-1.974.324-5.74-1.234-4.818-1.994-7.92-6.894-8.16-7.214-.232-.32-1.95-2.6-1.95-4.96s1.234-3.52 1.672-4.002c.39-.43 1.024-.644 1.632-.644.196 0 .372.01.53.018.438.02.658.046.948.732.362.858 1.246 3.038 1.354 3.26.11.222.22.52.07.82-.14.31-.264.448-.486.702-.222.254-.432.448-.654.722-.2.24-.426.496-.182.934.244.43 1.086 1.792 2.332 2.904 1.602 1.43 2.912 1.886 3.39 2.086.344.144.754.108.998-.162.308-.344.688-.914 1.076-1.476.274-.4.62-.45.996-.306.38.136 2.406 1.134 2.818 1.34.412.208.686.31.786.482.098.172.098.994-.292 2.094z" />
      </svg>
    </a>
  );
};

export default WhatsAppButton;

